import React, { createContext, useContext, useEffect, useState } from 'react';

const VersionContext = createContext();
const STORAGE_KEY = 'inceptum-ui-version';

export const useVersion = () => {
  const context = useContext(VersionContext);
  if (!context) {
    throw new Error('useVersion must be used within VersionProvider');
  }
  return context;
};

export const VersionProvider = ({ children }) => {
  const [isImprovedVersion, setIsImprovedVersion] = useState(() => {
    const savedValue = window.localStorage.getItem(STORAGE_KEY);
    if (savedValue === 'classic') {
      return false;
    }
    return true;
  });

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, isImprovedVersion ? 'latest' : 'classic');
  }, [isImprovedVersion]);

  const toggleVersion = () => {
    setIsImprovedVersion((previousValue) => !previousValue);
  };

  return (
    <VersionContext.Provider value={{ isImprovedVersion, toggleVersion }}>
      {children}
    </VersionContext.Provider>
  );
};

